import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';

@Injectable({
  providedIn: 'root'
})
export class IndustriasService extends Api {

  getAll() {
    return this.http.get(`${this.url}/industrias`);
  }

}
